import React from 'react';
import './LowboyTimesheet.scss';
import { Alert, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faExclamationTriangle,
    faThumbsUp,
    faUndo,
} from '@fortawesome/free-solid-svg-icons';
import { TimesheetStatus } from '../timesheet/Timesheet';
import { getKeyByValue } from '../utilities/ObjectHelpers';

export default class LowboyTimesheetStatusRow extends React.Component {
    getIsComplete = () => {
        const { lowboyTimesheet, isAdmin, isTimesheetApprover } = this.props;

        if (isTimesheetApprover) {
            return (
                lowboyTimesheet.timesheetStatusId >= TimesheetStatus.Approved
            );
        }

        if (isAdmin) {
            return (
                lowboyTimesheet.timesheetStatusId >= TimesheetStatus.Validated
            );
        }

        return lowboyTimesheet.timesheetStatusId >= TimesheetStatus.Submitted;
    };

    getAlertColor = () => (this.getIsComplete() ? 'success' : 'warning');

    getTimesheetStatusName = () => {
        const { lowboyTimesheet } = this.props;

        return getKeyByValue(
            TimesheetStatus,
            lowboyTimesheet.timesheetStatusId
        );
    };

    render() {
        const { saving, loading, lowboyTimesheet, onRecall, isAdmin } =
            this.props;

        if (
            loading ||
            !lowboyTimesheet ||
            lowboyTimesheet.timesheetStatusId == TimesheetStatus.New
        ) {
            return null;
        }

        const alertColor = this.getAlertColor();
        const isComplete = this.getIsComplete();

        const timesheetStatusName = this.getTimesheetStatusName();

        return (
            <>
                {lowboyTimesheet.rejectionNotes && (
                    <Alert fade={false} color="danger" className="mt-2">
                        <FontAwesomeIcon
                            icon={faExclamationTriangle}
                            className="mr-1"
                        />
                        This timesheet has been rejected. The following feedback
                        was provided.
                        <pre>{lowboyTimesheet.rejectionNotes}</pre>
                    </Alert>
                )}

                {!lowboyTimesheet.rejectionNotes && (
                    <Alert fade={false} color={alertColor} className="mt-2">
                        <div className="d-flex w-100">
                            <div className="my-auto">
                                {isComplete && (
                                    <FontAwesomeIcon
                                        icon={faThumbsUp}
                                        className="mr-1"
                                    />
                                )}
                                This timesheet has been {timesheetStatusName}.
                            </div>
                            {!isAdmin &&
                                lowboyTimesheet.timesheetStatusId ==
                                    TimesheetStatus.Submitted && (
                                    <div className="w-25 ml-auto">
                                        <Button
                                            size="xl"
                                            color="danger"
                                            disabled={saving}
                                            className="w-100"
                                            onClick={onRecall}
                                        >
                                            <FontAwesomeIcon
                                                icon={faUndo}
                                                className="mr-2"
                                            />
                                            Recall for Edit
                                        </Button>
                                    </div>
                                )}
                        </div>
                    </Alert>
                )}
            </>
        );
    }
}
